/** Used to group downloaded data together with hash and loading status */
export class DownloadedDataSet<T> {
	/** Actual data payload, strongly typed */
	data: T;

	/** The hash of the data payload, as provided by the server, if any */
	hash = "";

	/** Most recent error message on data retrieval failure */
	errorMessage = "";

	/** Set to true while async download is underway */
	isLoading = false;

	/** Set to true if there has ever been a succesful download - i.e. some (possibly stale) data */
	hasReceivedData = false;

	/** Strongly typed constructor */
	constructor(initialData: T, hash: string) {
		this.data = initialData;
		this.hash = hash;
	}

	/** Creates a new object state with no errormessage and marks isLoading (retains any data) */
	static mutateToLoading(oldState: DownloadedDataSet<any>) {
		const mutated = new DownloadedDataSet<any>(oldState.data, oldState.hash);
		mutated.errorMessage = "";
		mutated.isLoading = true;
		mutated.hasReceivedData = oldState.hasReceivedData;
		return mutated;
	}

	/** Creates a new object state with an errormessage (retains any data) */
	static mutateToError(oldState: DownloadedDataSet<any>, newErrorMessage: string) {
		const mutated = new DownloadedDataSet<any>(oldState.data, oldState.hash);
		mutated.errorMessage = newErrorMessage;
		mutated.isLoading = false;
		mutated.hasReceivedData = oldState.hasReceivedData;
		return mutated;
	}

	static mutateToDownloaded(oldState: DownloadedDataSet<any>, newData: any, newHash: string) {
		const mutated = new DownloadedDataSet<any>(newData, newHash);
		mutated.errorMessage = "";
		mutated.isLoading = false;
		mutated.hasReceivedData = true;
		return mutated;
	}

	static mutateToNotModified(oldState: DownloadedDataSet<any>) {
		const mutated = oldState;
		mutated.errorMessage = "";
		mutated.isLoading = false;
		mutated.hasReceivedData = true;
		return mutated;
	}

}
